export enum SessionStorageKey {
  CONTEXT_ID = 'contextId',
  CONTACT_ID = 'contactId',
  TIMEOUT_URL = 'timeoutUrl',
  LOGOUT_URL = 'logoutUrl',
  DELEGATES_BANNER_DISMISS = 'delegatesBannerDismiss',
}

const setItem = (key: SessionStorageKey, value: string): void => {
  window.sessionStorage.setItem(key, value);
};

const removeItem = (key: SessionStorageKey): void => {
  window.sessionStorage.removeItem(key);
};

const getItem = (key: SessionStorageKey): string | undefined => window.sessionStorage.getItem(key) as string | undefined;

const clear = () => window.sessionStorage.clear();

export default {
  clear,
  setItem,
  removeItem,
  getItem,
};
